import React from 'react';
import PropTypes, { any } from 'prop-types';

import styles from './nextAvailable.scss';
import AddDrawsListItem from './AddDrawsListItem';

const SelectableDrawList = (props) => {
    const {
        className,
        title,
        draws,
        field,
        formApi,
    } = props;

    return (
        <div className={`${className} ${styles.selectableDrawList}`}>
            <div className={styles.title} data-testid={`next-available.add-draws.${field}.title`}>
                {title}
            </div>
            <div className={styles.list}>
                {draws.map((draw, i) => {
                    return (
                        <AddDrawsListItem
                            key={draw.customDrawId}
                            draw={draw}
                            field={field}
                            index={i}
                            formApi={formApi}
                        />
                    );
                })}
            </div>
        </div>
    );
};

SelectableDrawList.propTypes = {
    className: PropTypes.string,
    title: PropTypes.string.isRequired,
    field: PropTypes.string.isRequired,
    formApi: PropTypes.objectOf(any).isRequired,
    draws: PropTypes.arrayOf(any),
};

SelectableDrawList.defaultProps = {
    className: null,
    draws: [],
};

export default SelectableDrawList;
